export default "__VITE_ASSET__DIYYStQJ__"